import React from "react";
import { Box } from "@mui/material";

const Work = () => {
  return (
    <Box width={"100vw"} color={"#fff"} height={"100vh"}>
      Work
    </Box>
  );
};

export default Work;
